import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { colors } from '../../../../constants'
import ContentButton from '../../../../containers/Content/Content/ContentButton'
import type { ExtendedLayer } from '../../../../containers/Content/Content/types'
import { FileUtils } from '../../../../utils'

interface CurrentLayerProps {
    layer: ExtendedLayer;
    onClick: () => void;
}

const LayerButton = styled(ContentButton)`
    color: ${colors.black};
    text-align: left;
    text-shadow: none;
    vertical-align: baseline;
    width: 100%;

    &:hover {
        color: ${colors.blue};
    }
`

const LayerName = styled.span`
    font-weight: bold;
`

const LayerSize = styled.span`
    margin: 0 5px;
`

const EditIcon = styled(FontAwesomeIcon)`
    color: ${colors.blue};
`

export default function CurrentLayer({ layer, onClick }: CurrentLayerProps) {
    return (
        <LayerButton
            onClick={onClick}
            theme="light"
            title={"Change layer"}
        >
            <LayerName>{layer.name}</LayerName>
            <LayerSize>{FileUtils.humanFileSize(layer.file_size)}</LayerSize>
            <EditIcon icon="edit" size="1x" />
        </LayerButton>
    )
}
